// frontend/src/config.js
// Centralized frontend configuration.

// API base URL for the Django backend.
// - In development: defaults to local Django server at :8000
// - In production: defaults to api.kanalytics.co.bw (the Django backend server)
//
// Override at build time with REACT_APP_API_BASE_URL if the API host changes.
// Must include the trailing slash because code concatenates paths (e.g. `${API_BASE_URL}auth/login/`).
const envBaseUrl = process.env.REACT_APP_API_BASE_URL;

let inferredBaseUrl = envBaseUrl;
if (!inferredBaseUrl) {
	const hostname = (typeof window !== 'undefined' && window.location && window.location.hostname) ? window.location.hostname : '';

	if (hostname === 'localhost' || hostname === '127.0.0.1') {
		// Local development: Django dev server on port 8000
		inferredBaseUrl = 'http://127.0.0.1:8000/api/v1/';
	} else {
		// Production: the React SPA is on legalops.kanalytics.co.bw but the
		// Django API lives on api.kanalytics.co.bw.  Sending /api/ requests to
		// the SPA origin returns index.html (404) because there is no reverse-
		// proxy on the frontend host.  Point directly at the API server instead.
		inferredBaseUrl = 'https://api.kanalytics.co.bw/api/v1/';
	}
}

export const API_BASE_URL = String(inferredBaseUrl).replace(/\/+$/, '/')
